import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class WhatsappTemplateService {

  private endpoint: string = 'https://us-central1-trosten-efcb3.cloudfunctions.net/sendSimpleWhatsapp';

  constructor(private http: Http) { }

  buildPayload(contactoTel: string, messageType: string, params: any, dryRun?: boolean): any {
    return {
      contacto_tel: contactoTel ? contactoTel.toString().trim() : '',
      messageType: messageType,
      params: params || {},
      dryRun: !!dryRun
    };
  }

  sendTemplateMessage(contactoTel: string, messageType: string, params: any, dryRun?: boolean): Observable<any> {
    var payload = this.buildPayload(contactoTel, messageType, params, dryRun);

    return this.http.post(this.endpoint, payload).map(function(res: any) {
      return res && res.json ? res.json() : res;
    });
  }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/integration/whatsapp-template.service.ts